import { InjectionToken } from '@angular/core';

/**
 * Whether the auth interceptor may recover from a `401` by fetching a fresh
 * token from `GET /v1/token` and retrying the request once.
 *
 * Off by default, because that endpoint issues a wildcard (`orgId: all`) token:
 * only a host that is already entitled to one should fall back to it. The main
 * app opts in; the embeddable widget must not, since it carries a round-scoped
 * token supplied by its parent. Set via {@link provideFeedbackApi}.
 */
export const FEEDBACK_API_TOKEN_REFRESH_ENABLED = new InjectionToken<boolean>(
  'FEEDBACK_API_TOKEN_REFRESH_ENABLED',
  { factory: () => false },
);
